import React from 'react';
import _ from 'lodash';
import cn from 'classnames';
import Button, {ButtonStyles} from 'components/common/Form/Button';
import Modal from './Modal';
import Input from 'components/common/Form/Input';

import {useForm} from 'hooks/common/useForm';

import styles from './Modal.module.scss';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

export default function ConfirmDialog({
    title,
    text,
    confirmDisabled = false,
    closeOutside = true,
    okLabel = 'Yes',
    cancelLabel = 'No',
    textInput = false,
    onConfirm = _.noop,
    onCancel = _.noop,
    onClose = _.noop,
    bodyStyle = '',
    primaryButton = false,
    textInputNote,
    textInputInitial = '',
    textInputError,
    inputLabel = 'Details',
    withWhitespace,
    processing = false,
    textarea = true,
    className,
}) {
    const {values, onChangeField} = useForm({values: {details: textInputInitial}});

    return (
        <Modal className={className} onClose={onClose}>
            <div className={cn(styles.body, bodyStyle)}>
                <div className={styles.title}>{title}</div>
                <div className={cn(styles.text, {[styles.withWhitespace]: withWhitespace})}>{text}</div>
                {textInput && (
                    <Input
                        textarea={textarea}
                        fullWidth
                        name='details'
                        label={inputLabel}
                        value={values.details}
                        rows={5}
                        onChangeField={onChangeField}
                        note={textInputNote}
                        error={textInputError}
                    />
                )}
                <div className={styles.buttons}>
                    <Button
                        className={styles.button}
                        text={cancelLabel}
                        onClick={() => {
                            onCancel();
                            onClose();
                        }}
                        btnStyle={ButtonStyles.secondary}
                    />
                    {processing ? (
                        <div className={styles.spinnerContainer}>
                            <LoadingSpinner />
                        </div>
                    ) : (
                        <Button
                            className={styles.button}
                            text={okLabel}
                            disabled={confirmDisabled}
                            onClick={() => {
                                onConfirm(values.details);
                                closeOutside || onClose();
                            }}
                            btnStyle={primaryButton ? ButtonStyles.primary : ButtonStyles.secondary}
                        />
                    )}
                </div>
            </div>
        </Modal>
    );
}
